import { NavbarDropdownData } from "@/store/navigation/types";
import navbarData from "@/data/docs/navbar.json";

export const navbarNavData: NavbarDropdownData[] = Object.values(navbarData);
